import React, { useEffect, useContext } from "react"
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PrimaryButton from "../Button/PrimaryButton";
import SecondButton from "../Button/SecondButton";
import LineArrowRight from "../Icons/LineArrowRight";
import PhoneIcon from "../Icons/PhoneIcon";
import WidthIcon from "../Icons/WidthIcon";
import HeightIcon from "../Icons/HeightIcon";
import LengthIcon from "../Icons/LengthIcon";
import {
  ProductCard,
  ProductBody,
  ProductSku,
  ProductFigure,
  ProductName,
  ProductInfoText,
  Measurement,
  MeasurementItem,
  ProductCta,
  ProductItemCta,
} from "../ProductStyle";

import { Context } from "../../layouts/context";

const ProductCards = ({ data }) => {
  const {popupContext, setPopupContext} = useContext(Context);
    const HandleModalOpen = () => {
      setPopupContext({
        isVisible: true
      })
    }
    useEffect(() => {
        if (popupContext.isVisible===true) {
            document.querySelector("body").classList.add("modal-open")
        } else {
            document.querySelector("body").classList.remove("modal-open")
        }
    }, [popupContext, setPopupContext])
  return (
    <ProductCard className="card">
      <ProductFigure className="card-figure">
        <Link to={data.url} className="card-link"><GatsbyImage image={getImage(data.image.gatsbyImageData)} alt={data.name}/></Link>
      </ProductFigure>
      <ProductBody className="card-body">
        <ProductSku className="product-sku">SKU : {data.sku}</ProductSku>
        <ProductName className="product-name"><Link to={data.url}>{data.name}</Link></ProductName>
        <Measurement className="measurement">
          <MeasurementItem className="measurement-item">
            <span className="icon"><WidthIcon /></span>
            <span className="text">
              <small>Width</small>
              <strong>{data.width}</strong>
            </span>
          </MeasurementItem>
          <MeasurementItem className="measurement-item">
            <span className="icon"><LengthIcon /></span>
            <span className="text">
              <small>Length</small>
              <strong>{data.length}</strong>
            </span>
          </MeasurementItem>
          {data.category?.name !== "Gazebos" &&
            data.subCategory?.name !== "Metal Barns" && (
              <MeasurementItem className="measurement-item">
                <span className="icon"><HeightIcon /></span>
                <span className="text">
                  <small>Height</small>
                  <strong>{data.height}</strong>
                </span>
              </MeasurementItem>
            )}
        </Measurement>        
        <ProductCta>
          <ProductItemCta className="product-item-cta">
            <a href="tel:3867556449"><SecondButton text="(386) 755-6449" preIcon={<PhoneIcon fill="#ffffff" />} /></a>
          </ProductItemCta>
          <ProductItemCta className="product-item-cta">
            <button type="button" onClick={HandleModalOpen} aria-hidden="true"><PrimaryButton text="Get a quote" icon={<LineArrowRight />} /></button>
          </ProductItemCta>
        </ProductCta>
        <ProductInfoText>* Price may vary with states and certification requirement</ProductInfoText>
      </ProductBody>
    </ProductCard>
  );
};

export default ProductCards;
